export const REPORT_SPECIES = ['bee', 'orientalisWasp', 'other', 'unknown'] as const;

export const REPORT_HABITAT_TYPES = [
  'urbanArea',
  'agriculturalArea',
  'naturalArea',
  'coastalArea',
  'other',
] as const;

export const REPORT_OBSERVATION_TYPES = ['nest', 'individual'] as const;

export const REPORT_REVIEW_STATUSES = ['awaitingReview', 'confirmed', 'rejected'] as const;
